module.exports = __webpack_public_path__ + "media/images/v2/icons/carousel-dot.svg";